// extracted by mini-css-extract-plugin
export var danger = "_37-6";
export var lightPink = "_37-a";
export var medium = "_37-j";
export var nearSquare = "_37-m";
export var neutralBlue = "_37-8";
export var neutralYellow = "_37-7";
export var noCapitalize = "_37-1";
export var normal = "_37-2";
export var pill = "_37-0";
export var primary = "_37-3";
export var primaryLight = "_37-4";
export var shadow = "_37-n";
export var small = "_37-k";
export var solidBlack = "_37-i";
export var solidGreen = "_37-d";
export var solidLightBlue = "_37-f";
export var solidNavy = "_37-e";
export var solidOrange = "_37-h";
export var solidPink = "_37-g";
export var solidRed = "_37-b";
export var solidWhite = "_37-9";
export var solidYellow = "_37-c";
export var success = "_37-5";
export var xsmall = "_37-l";